module.exports = __webpack_public_path__ + "static/media/darkBG-old.1021b86c.png";